import { useIntl } from "react-intl";
import { observer } from "mobx-react-lite";

import { urlDecorator } from "../../utils/api";

import Menu from "../menu/Menu";
import Steps from "./steps/Steps";
import Logo from "./Logo";

import HeaderButton from "./HeaderButton";
import SaveProgressBar from "./SaveProgressBar";

import { ReactComponent as SmartGardenSVG } from "../../assets/smart-garden.svg";

import useStores from "../../hooks/useStores";

let Header = () => {
  const intl = useIntl();
  const { formatMessage } = intl;

  const { uiState } = useStores();

  const { plan, stepIdx: currentStep, settingsState } = uiState;

  const labels = settingsState.texts.header;

  return (
    <header>
      <SaveProgressBar saveStatus={uiState.saveStatus} />
      <Logo
        planName={uiState.planName}
        setPlanName={plan != null ? uiState.setPlanName : undefined}
        updatePlan={uiState.updatePlan}
        formatMessage={formatMessage}
        showPhoneNumber={currentStep >= 2}
        lastSaveDate={uiState.lastSaveDate}
        saveStatus={uiState.saveStatus}
      />
      <Steps />
      <div className="right">
        {plan?.sensors.length > 0 && (
          <HeaderButton
            className="smart-garden"
            href={
              settingsState
                ? urlDecorator(
                    settingsState.links.smartGardenURL.replace(
                      ":planId",
                      uiState.planId
                    )
                  )
                : "/"
            }
            rel="noopener noreferrer"
            target="planer"
            noredirect="true"
            Icon={({ width, height }) => (
              <div className="icon" style={{ width, height }}>
                <SmartGardenSVG />
              </div>
            )}
            label={
              labels
                ? formatMessage({ id: labels.smartGardenLabel })
                : undefined
            }
          />
        )}

        <Menu />
      </div>
    </header>
  );
};
Header = observer(Header);

export default Header;
